import { render, staticRenderFns } from "./notificationsMobile.vue?vue&type=template&id=0e20a1cf&scoped=true"
import script from "./notificationsMobile.vue?vue&type=script&lang=js"
export * from "./notificationsMobile.vue?vue&type=script&lang=js"
import style0 from "./notificationsMobile.vue?vue&type=style&index=0&id=0e20a1cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e20a1cf",
  null
  
)

export default component.exports